<div fxFlex="100" class="inputs justify-fxstart" fxLayout="row wrap">
    <div class="align-item-fxstart" fxFlex="100" fxLayout="column">
        <div class="expandable" fxLayout="column">
            <textarea name="remark" class="hw100" placeholder="Enter Remark" [(ngModel)]="remarks"
                id="remark"></textarea>
            <div class="icon-set">
                <i MatSuffix id="i1" matTooltip="Coming Soon" matTooltipPosition="below" matTooltipHideDelay="2000"
                    class="flaticon-attachment"></i>
                <i MatSuffix id="i1" matTooltip="Coming Soon" matTooltipPosition="below" matTooltipHideDelay="2000"
                    class="flaticon-happy"></i>
            </div>
            <mat-checkbox color="primary" *ngIf="!isCustomer" [(ngModel)]="is_internal">Visible only to
                internal Users</mat-checkbox>
        </div>
    </div>
    <button class="loadingBtn Save" mat-raised-button (click)="addNewRemarks()">
        <span>Add Remarks</span>
    </button>
</div>
<mat-card *ngFor="let remark of remarksList">
    <mat-card-header>
        <div mat-card-avatar>
            <logzy-img-loader
                [src]="remark.created_by?.picture == null ? remark.created_by?.gender == 'Male' ? base_url + '/media/profile_pics/man.svg' : remark.created_by?.gender == 'Female' ? base_url + '/media/profile_pics/woman.svg' : base_url + '/media/profile_pics/default_dp.svg' : remark.created_by?.picture?.document_file"
                border_radius="50%" [profilePic]="true" [initials]="remark.created_by?.initials" [background_color]="'#d5d5d5'"
                [span_color]="'#000000'"                class="profile-logo-round" [class.p-0]="true">
            </logzy-img-loader>
        </div>
        <mat-card-title>{{remark.created_by?.first_name + ' ' + remark.created_by?.last_name}}</mat-card-title>
        <mat-card-subtitle>{{remark.created_by?.email}}</mat-card-subtitle>
        <span class="reviewDate">Date: {{remark.created_at | date: 'dd MMM, yyyy'}}</span>
    </mat-card-header>
    <mat-card-content>
        <span class="remarkSpan">{{remark.remarks}}</span>
    </mat-card-content>
</mat-card>